import { helper } from '@ember/component/helper';

import { gt } from 'rise-ui/utils/choice.js';

export default helper(function gtHelper(params) {
  return gt(...params);
});
